import type React from 'react';

import { Separator, Text } from '@change/ds-core-ui';
import { CheckCurvedIcon } from '@change/ds-icons';

import { Html } from '#src/app/shared/components/html';

import { useComboCopy } from '../../hooks/useComboCopy';

export const TrimmedComboCopy: React.FC = () => {
	const {
		data: { description, subtitle, items },
	} = useComboCopy();

	return (
		<div className="flex flex-col gap-4">
			<Text variant="body" className="text-typography-weak">
				{description}
			</Text>
			<Text as="h3" variant="heading" size="xx-small">
				{subtitle}
			</Text>
			<ul className="m-0 flex list-none flex-col gap-3">
				{items.map((item, index) => (
					<li key={`${item}-${index}`} className="flex items-start gap-2">
						<CheckCurvedIcon className="text-icon-strong mt-1" size={16} />
						<Html as="div" html={item} className="text-typography-weak" />
					</li>
				))}
			</ul>
			<Separator className="mt-3 mb-0" />
		</div>
	);
};
